import '../styles.css';
import PageHeader from '../components/PageHeader';
import { storageAssets } from '../storage_assets';
import LazyVideo from '../components/LazyVideo';

/* Typography: see styles.css — .text-header-main, .text-body, .text-body-sm */

const ProjectFourPage = () => {
    return (
        <div className="scrollable-window scrollable-window--wide">
            <div style={styles.wholeThingBox}>
                <div style={styles.boxMain}>
                    <PageHeader title="Graphic design — BYU Athletics" />
                    <div className="text-body-sm">
                        Three years on the in-house creative team: game-day, recruiting, and social deliverables across static,
                        motion, and print. High volume, short timelines, full brand system. Below is a sample of that work.
                    </div>
                    <div style={styles.deviderStroke}></div>

                    <div className="text-body">Stills & print</div>
                    <div className="text-body-sm">
                        Social, environmental, and print pieces—typography and layout tuned for quick reads in feed and in venue.
                    </div>
                    <img src={storageAssets.heirarchyThree} alt="BYU Athletics graphic — hierarchy sample" style={styles.image} />
                    <img src={storageAssets.lineBacker} alt="BYU Athletics linebacker campaign graphic" style={styles.image} />

                    <div className="text-body">Motion & concepts</div>
                    <div className="text-body-sm">
                        Short-form motion and concept explorations for campaigns—type, pacing, and energy matched to the brief.
                    </div>
                    <LazyVideo src={storageAssets.readabilityThree} alt="BYU Athletics motion graphic clip" style={styles.image} />
                    <LazyVideo src={storageAssets.goalConcept} alt="BYU Athletics goal concept motion graphic" style={styles.image} />

                    <div className="text-body">Longer motion</div>
                    <div className="text-body-sm">
                        Pieces with a narrative arc: storyboards on paper first, then key art and animation for cuts that lived on
                        broadcast and social.
                    </div>
                    <LazyVideo src={storageAssets.storytellingOne} alt="BYU Athletics long-form motion piece" style={styles.image} />
                    <LazyVideo src={storageAssets.storytellingThree} alt="BYU Athletics long-form motion piece" style={styles.image} />
                </div>
            </div>
        </div>
    );
};

const styles = {
    wholeThingBox: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '40px',
        alignSelf: 'stretch',
        width: '100%',
        minWidth: 0,
        boxSizing: 'border-box',
    },
    boxMain: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '20px',
        width: 'var(--content-width)',
        maxWidth: '100%',
        minWidth: 0,
        padding: '0 clamp(1rem, 4vw, 2rem)',
        boxSizing: 'border-box',
        margin: '0',
        position: 'relative',
        zIndex: 1,
    },
    image: {
        width: 'var(--content-media-width)',
        height: 'auto',
        maxWidth: '100%',
    },
    deviderStroke: {
        height: '1px',
        backgroundColor: 'var(--color-border)',
        alignSelf: 'stretch',
    },
};

export default ProjectFourPage;
